export const testingLocallyContent = `# Testing Locally

* Supabase: use your project's **anon** key in the browser.
* Stripe: use **test** keys and test cards (e.g., \`4242 4242 4242 4242\`).
* Seed a demo tenant/app using your provisioning script (see **Getting Started → Provisioning**).

  * Copy the generated **publishable key** (\`pk_…\`) and \`appSlug\` into the Provider.`;
